import { render } from "./locationIcon.vue?vue&type=template&id=495498d5&lang=true"
import script from "./locationIcon.vue?vue&type=script&lang=js"
export * from "./locationIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__